import React, { useMemo } from 'react';
import AtBatLink from '@gameday/components/AtBat/components/AtBatLink';
import useTracking from '@gameday/utils/hooks/useTracking';

const buildAtBatOverlay = (playerId, atbatindex, content, openAtBatOverlay) => {

    if (!playerId || !openAtBatOverlay) {
        return content
    }
    const Tracking = useTracking();
    const handlers = useMemo((e) => {
        return {
            onClick:(e) => {
                Tracking.track.track_atbat_overlay_launch({
                    activity: 'Play Detail Click',
                    atBatClickplayIndex: atbatindex
                });

                openAtBatOverlay(e);
            }
        };
    }, [openAtBatOverlay, Tracking]);

    return <AtBatLink atbatindex={atbatindex} content={content} handlers={handlers} />;
};

export default buildAtBatOverlay;